import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingAccountStates = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_ACCOUNT_STATE] : (state,action)=>action.status
})

export default RetrievingAccountStates
